export const DocumentListingRootPath = "/";
export const UnauthorizedPagePath = "/unauthorized";
export const DisabledPagePath = "/inbound-central/disabled";
export const DocumentListingInboundCentralPath = "/inbound-central";
export const DocumentListingIndexExternalPath =
  "/inbound-central/index-external.html";
export const DocumentListingIndexInternalPath =
  "/inbound-central/index-internal.html";
export const InboundDocumentPath =
  "/inbound-central/countries/:countryCode/document-types/:documentType/documents/:documentId";
export const InboundDocumentPathWithInboundDocumentTab =
  "/inbound-central/countries/:countryCode/document-types/:documentType/documents/:documentId/:inboundDocumentTab";
export const NestPath = "/inbound-central/nest";
